import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// import ModalOnline from './ModalOnline';
import ModalErrorPayment from './ModalErrorPayment';
import ModalMilleniumPool from "./ModalMilleniumPool";
import ModalDolyameInfo from "./ModalDolyameInfo";
import ModalTinkoffLoanInfo from "./ModalTinkoffLoanInfo";
import ModalErrorAge from "./ModalErrorAge";

import { closeModal, changeTypeOfModal } from '../../actions/modals';

import './styles/modals.scss';
import ModalInstallmentsInfo from "./ModalInstallmentsInfo";
import ModalClubLoanInfo from "./ModalClubLoanInfo";
import ModalCreditInfo from "./ModalCreditInfo";
import ModalWidgetForm from "./ModalWidgetForm/ModalWidgetForm";

class Modals extends Component {

  // handler for close popup for ModalWindow
  // handleCloseModal(event) {
  //   if (event.target.classList.contains('modalWindow')) {
  //     this.props.closeModal();
  //     this.props.changeTypeOfModal(null);
  //   }
  // }

  render() {

    const {
      isActive,
      typeModal,
      modalInfo
    } = this.props;

    return (
      // <div className={`modalWindow ${isActive ? '_active' : ''}`} onClick={ this.handleCloseModal.bind(this) }>
      <div className={`modalWindow ${isActive ? '_active' : ''}`}>
        <div className="modalWindow__wrapper">
          <button className="modalWindow__close"
                  onClick={() => {
                    this.props.closeModal();
                    this.props.changeTypeOfModal(null);
                  }}
          >
            <img src={require('../../static/images/icons/icon-close-modal.svg').default} alt=""/>
          </button>
          <div className="modalWindow__body">
            {typeModal === 'widgetForm' &&
              <ModalWidgetForm
                modalInfo={modalInfo}
              />
            }
            {/* {
              typeModal === 'online' &&
              <ModalOnline
                changeTypeOfModal={ changeTypeOfModal }
                closeModal={ closeModal }
              />
            } */}

            {
              typeModal === 'errorPayment' &&
              <ModalErrorPayment
                changeTypeOfModal={changeTypeOfModal}
                closeModal={closeModal}
              />
            }
            {
              typeModal === 'milleniumPool' &&
              <ModalMilleniumPool
                changeTypeOfModal={changeTypeOfModal}
                closeModal={closeModal}
              />
            }
            {
              typeModal === 'dolyameInfo' &&
              <ModalDolyameInfo
                changeTypeOfModal={changeTypeOfModal}
                closeModal={closeModal}
                modalInfo={modalInfo}
              />
            }
            {
              typeModal === 'tinkoffLoanInfo' &&
              <ModalTinkoffLoanInfo
                changeTypeOfModal={changeTypeOfModal}
                closeModal={closeModal}
                modalInfo={modalInfo}
              />
            }
            {
              typeModal === 'clubLoanInfo' &&
              <ModalClubLoanInfo
                  changeTypeOfModal={changeTypeOfModal}
                  closeModal={closeModal}
                  modalInfo={modalInfo}
              />
            }
            {
              typeModal === 'creditInfo' &&
              <ModalCreditInfo
                  changeTypeOfModal={changeTypeOfModal}
                  closeModal={closeModal}
                  modalInfo={modalInfo}
              />
            }
            {
              typeModal === 'installmentsInfo' &&
              <ModalInstallmentsInfo
                changeTypeOfModal={changeTypeOfModal}
                closeModal={closeModal}
                modalInfo={modalInfo}
              />
            }
            {
              typeModal === 'errorAge' &&
              <ModalErrorAge
                changeTypeOfModal={changeTypeOfModal}
                closeModal={closeModal}
                modalInfo={modalInfo}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isActive: state.modals.isActive,
    typeModal: state.modals.typeModal,
    modalInfo: state.modals.modalInfo
  }
}
  
const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal,
  changeTypeOfModal
}, dispatch);
  
export default connect(mapStateToProps, mapDispatchToProps)(Modals);